unit View.Scripts.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils, UWeb.Enum,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewScriptsList = class(TForm)
    btNew: TButton;
    ScriptsDataset: TXDataWebDataSet;
    ScriptsDatasetid: TIntegerField;
    ScriptsDatasetusuario_id: TIntegerField;
    ScriptsDatasetscript_s3: TStringField;
    ScriptsDatasetscript_geral: TBooleanField;
    ScriptsDatasetinclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    ScriptsDatasetscript_tipo: TIntegerField;
    ScriptsDatasetusuario: TXDataWebEntityField;
    ScriptsDatasetusuarionome: TXDataWebDatasetField;
    ScriptsDatasetnome: TStringField;
    ScriptsDatasetscript_versao_minima: TStringField;
    ScriptsDatasetobservacao: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewScriptsList: TFViewScriptsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewScriptsList }

procedure TFViewScriptsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewScriptsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewScriptsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewScriptsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewScriptsList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewScriptsList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewScriptsList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewScriptsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewScriptsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ScriptsDataset.Connection.Model.DefaultSchema.FindEntityType(ScriptsDataset.EntitySetName),
      ScriptsDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_scripts');
  end;
end;

procedure TFViewScriptsList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['usuario.nome', 'script_s3', 'nome']) of
      0, 1, 2 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewScriptsList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['script_tipo', 'script_versao_minima']) of
      0:
      begin
        case StrToInt(AValue) of
          0 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Insert</div>';
          1 : AValue := '<div class="rounded-pill" style="background-color: #ffc107;color:white; padding-right: 5px;padding-left: 5px;">Update</div>';
          2 : AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Delete</div>';
          3 : AValue := '<div class="rounded-pill" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Alter</div>';
          4 : AValue := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">Create</div>';
        end;
      end;
      1:
      begin
        if AValue.IsEmpty then
          AValue := 'TODAS';
      end
      else
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewScriptsList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('scripts', 'active');
  TUtils.SetValorDicionarioClasses('scripts_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_scripts', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    ScriptsDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewScriptsList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(ScriptsDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewScriptsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.scripts.list.pagination.info');
  btNew := TButton.Create('view.scripts.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.scripts.list.table');
  cbPageSize := TComboBox.Create('view.scripts.list.cbPageSize');
  edSearch := TEdit.Create('view.scripts.list.search');
  lcPaginator := TListControl.Create('view.scripts.list.pagination');
  ScriptsDataset := TXDataWebDataSet.Create(Self);
  ScriptsDatasetid := TIntegerField.Create(Self);
  ScriptsDatasetusuario_id := TIntegerField.Create(Self);
  ScriptsDatasetscript_s3 := TStringField.Create(Self);
  ScriptsDatasetscript_geral := TBooleanField.Create(Self);
  ScriptsDatasetinclusao := TDateTimeField.Create(Self);
  ScriptsDatasetscript_tipo := TIntegerField.Create(Self);
  ScriptsDatasetusuario := TXDataWebEntityField.Create(Self);
  ScriptsDatasetusuarionome := TXDataWebDatasetField.Create(Self);
  ScriptsDatasetnome := TStringField.Create(Self);
  ScriptsDatasetscript_versao_minima := TStringField.Create(Self);
  ScriptsDatasetobservacao := TStringField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ScriptsDataset.BeforeLoadDFMValues;
  ScriptsDatasetid.BeforeLoadDFMValues;
  ScriptsDatasetusuario_id.BeforeLoadDFMValues;
  ScriptsDatasetscript_s3.BeforeLoadDFMValues;
  ScriptsDatasetscript_geral.BeforeLoadDFMValues;
  ScriptsDatasetinclusao.BeforeLoadDFMValues;
  ScriptsDatasetscript_tipo.BeforeLoadDFMValues;
  ScriptsDatasetusuario.BeforeLoadDFMValues;
  ScriptsDatasetusuarionome.BeforeLoadDFMValues;
  ScriptsDatasetnome.BeforeLoadDFMValues;
  ScriptsDatasetscript_versao_minima.BeforeLoadDFMValues;
  ScriptsDatasetobservacao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewScriptsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'Novo';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'usuario.nome';
      Title := 'Autor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'script_tipo';
      Title := 'Tipo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'script_geral';
      Title := 'Geral';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'script_versao_minima';
      Title := 'Vers'#227'o M'#237'nima';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'script_s3';
      Title := 'Caminho';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ScriptsDataset.SetParentComponent(Self);
    ScriptsDataset.Name := 'ScriptsDataset';
    ScriptsDataset.EntitySetName := 'Scripts';
    ScriptsDataset.Connection := DMConnection.ApiConnection;
    ScriptsDataset.Left := 72;
    ScriptsDataset.Top := 144;
    ScriptsDatasetid.SetParentComponent(ScriptsDataset);
    ScriptsDatasetid.Name := 'ScriptsDatasetid';
    ScriptsDatasetid.FieldName := 'id';
    ScriptsDatasetid.Required := True;
    ScriptsDatasetusuario_id.SetParentComponent(ScriptsDataset);
    ScriptsDatasetusuario_id.Name := 'ScriptsDatasetusuario_id';
    ScriptsDatasetusuario_id.FieldName := 'usuario_id';
    ScriptsDatasetusuario_id.Required := True;
    ScriptsDatasetscript_s3.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_s3.Name := 'ScriptsDatasetscript_s3';
    ScriptsDatasetscript_s3.FieldName := 'script_s3';
    ScriptsDatasetscript_s3.Required := True;
    ScriptsDatasetscript_s3.Size := 255;
    ScriptsDatasetscript_geral.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_geral.Name := 'ScriptsDatasetscript_geral';
    ScriptsDatasetscript_geral.FieldName := 'script_geral';
    ScriptsDatasetscript_geral.Required := True;
    ScriptsDatasetinclusao.SetParentComponent(ScriptsDataset);
    ScriptsDatasetinclusao.Name := 'ScriptsDatasetinclusao';
    ScriptsDatasetinclusao.FieldName := 'inclusao';
    ScriptsDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ScriptsDatasetscript_tipo.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_tipo.Name := 'ScriptsDatasetscript_tipo';
    ScriptsDatasetscript_tipo.FieldName := 'script_tipo';
    ScriptsDatasetscript_tipo.Required := True;
    ScriptsDatasetusuario.SetParentComponent(ScriptsDataset);
    ScriptsDatasetusuario.Name := 'ScriptsDatasetusuario';
    ScriptsDatasetusuario.FieldName := 'usuario';
    ScriptsDatasetusuarionome.SetParentComponent(ScriptsDataset);
    ScriptsDatasetusuarionome.Name := 'ScriptsDatasetusuarionome';
    ScriptsDatasetusuarionome.FieldName := 'usuario.nome';
    ScriptsDatasetnome.SetParentComponent(ScriptsDataset);
    ScriptsDatasetnome.Name := 'ScriptsDatasetnome';
    ScriptsDatasetnome.FieldName := 'nome';
    ScriptsDatasetnome.Required := True;
    ScriptsDatasetnome.Size := 255;
    ScriptsDatasetscript_versao_minima.SetParentComponent(ScriptsDataset);
    ScriptsDatasetscript_versao_minima.Name := 'ScriptsDatasetscript_versao_minima';
    ScriptsDatasetscript_versao_minima.FieldName := 'script_versao_minima';
    ScriptsDatasetscript_versao_minima.Size := 255;
    ScriptsDatasetobservacao.SetParentComponent(ScriptsDataset);
    ScriptsDatasetobservacao.Name := 'ScriptsDatasetobservacao';
    ScriptsDatasetobservacao.FieldName := 'observacao';
    ScriptsDatasetobservacao.Size := 255;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ScriptsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ScriptsDataset.AfterLoadDFMValues;
    ScriptsDatasetid.AfterLoadDFMValues;
    ScriptsDatasetusuario_id.AfterLoadDFMValues;
    ScriptsDatasetscript_s3.AfterLoadDFMValues;
    ScriptsDatasetscript_geral.AfterLoadDFMValues;
    ScriptsDatasetinclusao.AfterLoadDFMValues;
    ScriptsDatasetscript_tipo.AfterLoadDFMValues;
    ScriptsDatasetusuario.AfterLoadDFMValues;
    ScriptsDatasetusuarionome.AfterLoadDFMValues;
    ScriptsDatasetnome.AfterLoadDFMValues;
    ScriptsDatasetscript_versao_minima.AfterLoadDFMValues;
    ScriptsDatasetobservacao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
